import { Icon } from '../../../ui';

export interface SortState<Field extends string> {
  field: Field;
  dir: 'asc' | 'desc';
}

interface SortHeaderProps<Field extends string> {
  label: string;
  field: Field;
  sort: SortState<Field>;
  onSort: (next: SortState<Field>) => void;
  title?: string;
}

/** A table header that sorts by its column: first click descending, again to flip. */
export default function SortHeader<Field extends string>({ label, field, sort, onSort, title }: SortHeaderProps<Field>) {
  const active = sort.field === field;
  return (
    <button
      type="button"
      title={title}
      onClick={() => onSort({ field, dir: active && sort.dir === 'desc' ? 'asc' : 'desc' })}
      style={{
        font: 'inherit',
        color: 'inherit',
        background: 'transparent',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        letterSpacing: 'inherit',
        textTransform: 'inherit',
      }}
    >
      {label}
      <Icon
        name="chevron-down"
        size={11}
        style={{
          opacity: active ? 1 : 0.3,
          transform: active && sort.dir === 'asc' ? 'rotate(180deg)' : 'none',
          transition: 'transform var(--dur-base) var(--ease-out)',
        }}
      />
    </button>
  );
}
